exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "button-busy-indicator {\n  display: inline-block;\n  position: relative;\n  width: 16px;\n  height: 15px;\n}\n", ""]);

